"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cookie = _interopRequireDefault(require("cookie"));

var _default = function _default(fallBackUrlFn) {
  return function (result) {
    if (result.status === 401) {
      var rawCookie = _cookie.default.serialize('remembered', window.location.href, {
        maxAge: 60 * 10,
        path: '/'
      });

      document.cookie = rawCookie;
      window.location.assign(fallBackUrlFn());
      return Promise.reject(result);
    }

    return result;
  };
};

exports.default = _default;